import {
	Checkbox,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
} from 'components/mui';
import { CopyIcon, DeleteIcon } from 'components/icons';
import ChecklistEditor from '../checklistEditor/ChecklistEditor';
import ChecklistRows from './checklistRows/ChecklistRows';
import styles from './ChecklistTable.module.css';
import { getChecklistTableMessage } from '../../utils/getChecklistTableMessage';
import useChecklistTable from '../../hooks/useChecklistTable';
import ChecklistDeleteWarning from '../AlertDialog/ChecklistDeleteWarning';
import LoadingBackdrop from 'components/LoadingBackdrop';

const EnhancedTableHead = ({
	onDeleteChecklistClick,
	onCopyChecklistClick,
	onSelectAllChecklists,
	selectAll,
	checklistType,
}) => {
	return (
		<TableHead col>
			<TableRow>
				<TableCell align="left" className={styles.tableCell_01} />
				<TableCell align="left" className={styles.tableCell_02}>
					<Checkbox
						color="primary"
						checked={selectAll}
						onChange={onSelectAllChecklists}
					/>
				</TableCell>
				<TableCell align="left" className={styles.tableCell_03}>
					{checklistType} Checklist
				</TableCell>
				<TableCell align="left" className={styles.tableCell_04}>
					Description
				</TableCell>
				<TableCell align="right">
					<div>
						<IconButton
							color="inherit"
							onClick={onCopyChecklistClick}
						>
							<CopyIcon />
						</IconButton>
						<IconButton
							color="inherit"
							onClick={onDeleteChecklistClick}
						>
							<DeleteIcon />
						</IconButton>
					</div>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};
const ChecklistTable = ({
	openNewChecklist,
	customerID,
	addressID,
	checklistType,
	searchInput,
}) => {
	const state = useChecklistTable(
		customerID,
		addressID,
		checklistType,
		searchInput,
	);

	//--------DELETE FUNCTIONS END----------------//

	if (!state.searchedChecklists) {
		return <h1> Error Loading... Please try reloading the page.</h1>;
	}

	return (
		<div className={styles.root}>
			{/* <Paper className={styles.paper}> */}
			{openNewChecklist && (
				<ChecklistEditor
					checklists={state.searchedChecklists}
					setChecklists={state.setChecklists}
					checklistType={checklistType}
					customerID={customerID}
					addressID={addressID}
				/>
			)}

			<TableContainer>
				<Table
					className={styles.table}
					aria-labelledby="tableTitle"
					size={'small'}
					aria-label="enhanced table"
				>
					<EnhancedTableHead
						onDeleteChecklistClick={state.onDeleteChecklistClick}
						selectAll={state.selectAll}
						onSelectAllChecklists={state.onSelectAllChecklists}
						onCopyChecklistClick={state.onCopyChecklistClick}
						checklistType={checklistType}
					/>

					<TableBody>
						{state.searchedChecklists.length === 0 && (
							<TableRow>
								<TableCell
									colSpan={12}
									className={styles.tableCell_text}
								>
									{getChecklistTableMessage(
										state.error,
										state.checklists,
										customerID,
										addressID,
										state.pending,
									)}
								</TableCell>
							</TableRow>
						)}
						{state.searchedChecklists.length > 0 &&
							state.searchedChecklists
								.slice(
									state.page * state.rowsPerPage,
									state.page * state.rowsPerPage +
										state.rowsPerPage,
								)
								.map((row) => {
									return (
										<TableRow key={row.ChecklistID}>
											<ChecklistRows
												checklist={row}
												onSelectChecklistID={
													state.onSelectChecklistID
												}
												setChecklists={
													state.setChecklists
												}
											/>
										</TableRow>
									);
								})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component="div"
				count={state.checklists.length}
				rowsPerPage={state.rowsPerPage}
				page={state.page}
				onPageChange={(e, newPage) => state.setPage(newPage)}
				onRowsPerPageChange={state.handleChangeRowsPerPage}
			/>

			{state.deleteAlert && (
				<ChecklistDeleteWarning handler={state.deleteAlertHandlers} />
			)}
			{state.pending && <LoadingBackdrop open />}
		</div>
	);
};
export default ChecklistTable;
